import React from 'react';
import styles from "../styles/standings-widget.module.scss";
import classNames from "classnames";
import {BookmakersReviewWidgetAsync} from "../../bookmakers-review-widget/components/bookmakers-review-widget.async";

export const StandingsWidgetBookmakersReview = ({controller, isCollapsed, isPreviewStandings}) => {
  const {state} = controller;
  const {isWidget} = state;

  const shouldRenderBookmakersReview = !isPreviewStandings && !isCollapsed && !isWidget

  return (
    shouldRenderBookmakersReview ? <div className={classNames(styles.additional_widget)}>
      <BookmakersReviewWidgetAsync/>
    </div> : null
  )
};
